import MyOrder from './MyOrder.vue';

export default MyOrder;
